import { FeatureButton } from '../../access/FeatureButton';
import { SettlementAgreementStatus } from '../../../types/bid-as-dealer/SettlementAgreementStatus';
import { SettlementAgentAgreement } from '../../../types/bid-as-dealer/SettlementAgentAgreement';
import { roles } from '../../../constants';
import { RoleActionBlocker } from '../../access/RoleActionBlocker';

interface RequestAllToAllTradingContentProps {
    setContactsPopupVisible: (visible: boolean) => void
    setPopupVisible: (visible: boolean) => void
    agreement?: SettlementAgentAgreement
}

export const RequestAllToAllTradingContent = ({ agreement, setContactsPopupVisible, setPopupVisible }: RequestAllToAllTradingContentProps) => {
    switch (agreement?.agreementStatus) {
        case SettlementAgreementStatus.rejected:
            return (
                <BannerSuspendedState
                    companyName={agreement.settlementAgent.name}
                    onOpenContactsPopup={() => setContactsPopupVisible(true)}
                />
            )
        case SettlementAgreementStatus.pending:
            return (
                <BannerPendingState
                    companyName={agreement.settlementAgent.name}
                    onOpenContactsPopup={() => setContactsPopupVisible(true)}
                />
            )
        default:
            return <BannerNoneState onShowVisibleRequestPopup={() => setPopupVisible(true)} />;
    }
}

function BannerNoneState({ onShowVisibleRequestPopup }: { onShowVisibleRequestPopup: () => void }) {
    return (
        <>
            Request approval from KopenTech Capital Markets to enable All-to-All trading protocol.
            <div className="links">
                <a href="https://kopentech.com/" rel="noopener noreferrer" target="_blank">Read&nbsp;More</a>or
                <RoleActionBlocker roles={[roles.SellerTrader, roles.BrokerDealerTrader]}>
                    <FeatureButton
                        className="btn btn-main btn-sm"
                        onClick={onShowVisibleRequestPopup}
                    >
                        SEND REQUEST
                    </FeatureButton>
                </RoleActionBlocker>
            </div>
        </>
    )
}

function BannerPendingState(
    {
        companyName,
        onOpenContactsPopup
    }: { companyName: string, onOpenContactsPopup: () => void }) {
    return (
        <>
            The bidding request has been successfully submitted. Please contact&nbsp;<button className="btn-link btn-link-lg secondary regular" onClick={onOpenContactsPopup}>{companyName}</button>&nbsp;for more details.
        </>
    )
}

function BannerSuspendedState(
    {
        companyName,
        onOpenContactsPopup
    }: { companyName: string, onOpenContactsPopup: () => void }) {
    return (
        <>
            The bidding request has been suspended. Please contact&nbsp;<button className="btn-link btn-link-lg secondary regular" onClick={onOpenContactsPopup}>{companyName}</button>&nbsp;for more details.
        </>
    )
}